<template>
  <v-layout align-content-start row wrap justify-start>
    <v-flex xs12>
      <div class="section-header" row wrap align-content-center justify-center>
        <h1 class="section-title">
          <v-icon color="deep-orange darken-2">fal fa-dumbbell</v-icon>
          Treinos
        </h1>
      </div>
    </v-flex>
    <new-training :currentTraining="newCurrentTraining" :saveIntoModel="true" v-if="newCurrentTraining"></new-training>
  </v-layout>
</template>

<script>
import axios from 'axios'
// import router from '@/router'
import EventBus from '@/event-bus'
import NewTrainingComponent from '@/components/admin/trainings/NewTrainingComponent'

export default {
  data: () => ({
    newCurrentTraining: null
  }),

  components: {
    'new-training': NewTrainingComponent
  },

  methods: {
    loadTrainingItem () {
      EventBus.$emit('appLoading', true)
      // eslint-disable-next-line
      axios.get(`${API.userTrainings}/${this.$route.params.id}`).then(response => {
        this.newCurrentTraining = response.data.training
        EventBus.$emit('appLoading', false)
      }).catch(errors => {
        EventBus.$emit('showSnackbar', { message: 'Erro ao carregar o treino', color: 'error' })
        EventBus.$emit('appLoading', false)
      })
    }
  },

  beforeDestroy () {
    EventBus.$off('loadTrainingItem')
    EventBus.$off('updateTraining')
  },

  created () {
    this.loadTrainingItem()
    EventBus.$on('loadTrainingItem', this.loadTrainingItem)
    EventBus.$on('updateTraining', updateTraining => {
      this.newCurrentTraining = updateTraining
    })
  }
}
</script>



// WEBPACK FOOTER //
// src/components/admin/trainings/AdminEditTraining.vue